"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isLatchMoveLegal = void 0;
const blockwise_1 = require("blockwise");
function isLatchMoveLegal(puzzle, movedBlock) {
    if (puzzle.bits.some(b => (0, blockwise_1.isBlockColliding)(b.block, movedBlock))) {
        return false;
    }
    const guideBlock = { x: 0, y: 2, h: 1, w: puzzle.block.w };
    if (!(0, blockwise_1.isBlockIncluding)(guideBlock, movedBlock)) {
        return false;
    }
    return true;
}
exports.isLatchMoveLegal = isLatchMoveLegal;
